import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { LoadingPanel } from "../../LoadingPanel";
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";

import './Venue.scss';

export const AdministratorMatchVenue = (props) => {
    const dispatch = useDispatch();

    const [venues, setVenues] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [venueName, setVenueName] = useState(props.venueName);
    const [venueCity, setVenueCity] = useState(props.venueCity);
    const [venueRegionCode, setVenueRegionCode] = useState(props.venueRegionCode);
    const [venuePostalCode, setVenuePostalCode] = useState(props.venuePostalCode);
    const [venueCountryCode, setVenueCountryCode] = useState(props.venueCountryCode);

    const findVenues = () => {
        setIsLoading(true);

        const dataItem = {
            venueKey: props.venueKey,
            venueName: venueName,
            city: venueCity,
            regionCode: venueRegionCode,
            postalCode: venuePostalCode,
            countryCode: venueCountryCode,
        };
    
        fetch(`/api/administrator/pos/venues`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setVenues(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const SelectCell = (cellProps) => {  
        const venueId = cellProps.dataItem.id;
        
        return (
            <td>
                <Button type={"button"} onClick={() => props.savePOSVenueId(venueId)}>Select</Button>
            </td>
        );
    };

    const venueNameChanged = (event) => {
        setVenueName(event.value);
    };

    const venueCityChanged = (event) => {
        setVenueCity(event.value);
    };

    const venueRegionCodeChanged = (event) => {
        setVenueRegionCode(event.value);
    };

    const venuePostalCodeChanged = (event) => {
        setVenuePostalCode(event.value);
    };

    const venueCountryCodeChanged = (event) => {
        setVenueCountryCode(event.value);
    };

    useEffect(() => {
        if (props.venueName) {
            findVenues();
        }
    }, []);

    return (
        <div>
            <div className="mb-3">
                <Label>Find Venue:</Label> 

                <div className="row">
                    <div className="col-md-3">
                        <Input 
                            id={"venueName"} 
                            placeholder="Venue name" 
                            defaultValue={props.venueName}
                            onChange={venueNameChanged} />
                    </div>
                    <div className="col-md-3">
                        <Input 
                            id={"city"} 
                            placeholder="City" 
                            defaultValue={props.venueCity}
                            onChange={venueCityChanged} />
                    </div>
                    <div className="col-md-2">
                        <Input 
                            id={"regionCode"} 
                            placeholder="Region code" 
                            defaultValue={props.venueRegionCode}
                            onChange={venueRegionCodeChanged} />
                    </div>
                    <div className="col-md-2">
                        <Input 
                            id={"postalCode"} 
                            placeholder="Postal code" 
                            defaultValue={props.venuePostalCode}
                            onChange={venuePostalCodeChanged} />
                    </div>
                    <div className="col-md-2">
                        <Input 
                            id={"countryCode"} 
                            placeholder="Country code" 
                            defaultValue={props.venueCountryCode}
                            onChange={venueCountryCodeChanged} />
                    </div>
                </div>
                
                <Button
                    themeColor={"primary"}
                    type={"button"}
                    onClick={findVenues}
                    className="mt-2"
                    >
                    Find
                </Button>
            </div>

            <Grid
                data={venues}
                resizable={false}
                scrollable="none"
                >
                <Column field="name" title={"Name"} />
                <Column field="city" title={"City"} />
                <Column field="region" title={"Region"} />
                <Column field="postalCode" title={"Postal code"} />
                <Column field="countryCode" title={"Country"} />
                <Column cell={SelectCell} />
            </Grid>

            {isLoading ? <LoadingPanel /> : <></>}
        </div>
    );
}